<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<div class="container">

			<div class="import-box mt-2 mb-4 pb-3" >
				<h2 class="mt-4 text-center">Imprimir etiquetas</h2>
				<p class="text-center">
					Seleccione los vehículos para imprimir sus etiquetas de identificación
				</p>
			</div>

			<div class="container">
				<div class="row">
					<div class="col-6">

						<div class="d-flex align-items-end justify-content-between">
							<div class="form-group flex-grow-1">
								<label>Buscar vehículos</label>
								<div class="input-group">
									<input type="text" 
										class="form-control" 
										placeholder="Lote, chasis, motor, marca, modelo" 
										v-model="searchTerms"
										@keyup="searchCars()"
										@keyup.enter="searchCars()"
										>
									<div class="input-group-append">
										<button @click="searchCars()" class="btn btn-outline-secondary" type="button">Buscar</button>
									</div>
								</div>
							</div>

							<div class="form-group">
								<select class="form-control" 
									v-model="filterStatus" 
									@change="searchCars()">
									<option value="">Todos</option>
									<option value="PRE_ADMITTED">Pre ingresados</option>
									<div class="dropdown-divider"></div>
									<option value="IN_CUSTOMS_DEPOSIT"> Sin despachar</option>
									<option value="CUSTOMS_DISPATCHED">Despachados</option>
									<option value="WITHOUT_PRE_DELIVERY">Pendientes de pre entregar</option>
									<option value="PRE_DELIVERY_DONE">Pre entregas realizada</option>
									<option value="DELIVERY_REQUESTED">Entregas solicitadas</option>
									<option value="DELIVERY_SCHEDULED">Entregas programadas</option>
									<option value="DELIVERED">Entregados</option>
								</select>           
							</div>
						</div>

						<div class="label mt-4">
							<div class="btn btn-sm btn-light" @click="selectAll()">Seleccionar todos</div>
						</div>

						<div class="alert alert-warning" v-if="!loading && cars.length==0">
							No se han encontrado vehículos que coincidan con: {{searchTerms}}
						</div>

						<table class="table mt-2 mb-4" v-if="filteredCars.length>0">
							<tr class="table-head">
								<td>Lote</td>
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
							</tr>
							<tr v-for="item of filteredCars" :key="item.id"  @click="selectCar(item)">
								<td>
									<div class="tc">
										<span>{{item.lote}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span>{{item.chassis_number}}</span>
										<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
							</tr>
						</table>

					</div>


					<div class="col-6">

						<b-form-group label="DUA Tránsito" v-if="action == 'dua-transit'">
							<b-form-input
								v-model="form.dua_transit"
								placeholder="Número DUA Tránsito"
								:class="{'is-invalid':validation.hasError('form.dua_transit')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de dua tránsito</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group label="DUA Importación" v-if="action == 'dua-import'">
							<b-form-input
								v-model="form.dua_import"
								placeholder="Número DUA importación"
								:class="{'is-invalid':validation.hasError('form.dua_import')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de dua importación</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group label="Comprobante" v-if="action == 'dua-import'" class="mt-3">
							<UploadFile 
								v-model="form.file" 
								placeholder="Adjuntar comprobante"
								:invalid="validation.hasError('form.file.id')"
								:invalid-text="'Debe subir el comrpobante de despacho'"
							></UploadFile>
						</b-form-group>


						<b-form-group label="Stock" v-if="action == 'stock'">
							<b-form-input
								v-model="form.stock"
								placeholder="Stock"
								:class="{'is-invalid':validation.hasError('form.stock')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de stock</b-form-invalid-feedback>
						</b-form-group>
						
					
						<div class="label mt-4">
							Vehículos seleccionados
						</div>

						<div class="label mt-4">
							<div class="btn btn-sm btn-light" @click="deselectAll()">Deseleccionar todos</div>
						</div>

						<div class="alert alert-danger" v-if="validation.hasError('form.cars')">Debe seleccionar al menos un vehículo</div>

						<table class="table mt-2 mb-4" v-if="form.cars.length>0">
							<tr class="table-head">
								<td>Lote</td>
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
								<td></td>
							</tr>
							<tr v-for="(item, index) of form.cars" :key="item.id">
								<td>
									<div class="tc">
										<span>{{item.lote}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span>{{item.chassis_number}}</span>
										<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									</div>
									<vue-qrcode :value="JSON.stringify({ 
										'id': item.id,
										'chassis_number': item.chassis_number
									})" :id="`bc_${item.id}`" style="display:none" />
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
								<td>
									<div class="btn btn-xs btn-light" @click="deselectCar(index)"><i class="fa fa-times"></i></div>
								</td>
							</tr>
						</table>

						<div class="overflow-hidden mt-3">
							<button type="submit" class="btn btn-primary pull-right" @click="exportPDF()" >Generar PDF</button>
						</div>

					</div>

				</div>
			</div>

		</div>
	</div>

	<Loader :show="saving || loading"></Loader>
	
</div>
</template>

<script>
import jsPDF from 'jspdf'
// import JsBarcode from 'jsbarcode'
import VueQrcode from 'vue-qrcode'

import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import UploadFile from '@/components/UploadFile'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'printLabel',
	components:{
		Navbar,
		Loader,
		UploadFile,
		VueQrcode
	},
	mixins: [mixins],
	data () {
		return {
			title: null,
			action: null,
			searchTerms:null,
			search_timeout: null,
			form: {
				cars:[],
			},
			filterStatus: 'PRE_ADMITTED',
			cars: [],
			loading: false,
			saving: false,
		}
	},
	computed: {
		filteredCars: function () {
			return this.cars.filter((car) => {
				if( this.form.cars.map( el => el.id ).indexOf(car.id) < 0 ){
					return car
				}
			}
		)}
	},
	beforeMount(){
		// this.searchCars()
	},
	validators: {
		'form.cars': function (value) {
			return Validator.custom( () => {
				if(value.length<=0){
					return true
				}
			})
		},
	},
	
	methods: {
		selectAll(){
			this.form.cars = this.filteredCars
		},
		deselectAll(){
			this.form.cars = {}
		},
		selectCar(event){
			this.form.cars.push(event)
		},
		deselectCar(index){
			this.form.cars.splice(index,1)
		},
		searchCars(){
			if(this.search_timeout) clearTimeout(this.search_timeout);
			this.search_timeout = setTimeout(() => {
				
				this.loading = true
				this.$apollo.query({
					query: gql`query namedquery($search: String, $status: String) {
						carsAll(search: $search, status: $status) {
							id
							client{
								name
							}
							model
							brand{
								title
							}
							motor_number
							chassis_number
							dua_stock
							color{
								title
							}
							lote
							status
							statusText
						}
					}`,
					operationName: "Search",
					variables: {
						search: this.searchTerms,
						status: this.filterStatus
					},
				})
				.then((data) => {
					this.loading = false
					this.cars = data.data.carsAll;
				});

			}, 300);
		},
		async exportPDF() {
			if(!this.saving && await this.checkValidation() ) {

				var doc = new jsPDF({
					orientation: 'p',
					unit: 'mm',
					format: [283.46, 283.46], // points = 10x10
					putOnlyUsedFonts:true,
					floatPrecision: 16 // or "smart", default is 16
				})
				var now = new Date()
				now = this.$moment(now).format('DD/MM/YYYY HH:mm')

				this.form.cars.forEach( (car, index) => {
					let img = document.querySelector(`img#bc_${car.id}`)	
					doc.addImage(img.src, 'JPEG', 40, 40, 60, 60)
					let mt= 12

					let logo = require('@/assets/logo.png')
					doc.addImage(logo, 'JPEG', 0, 0, 60, 18)

					
					mt +=8
					doc.setFontSize(8).setTextColor(0)
					doc.text("CHASIS", 8, mt)
					mt +=7
					doc.setFontSize(22).setTextColor(0)
					doc.text(car.chassis_number, 8, mt)
					mt +=5

					doc.setFontSize(8).setTextColor(0)
					doc.text("STOCK", 8, mt)
					mt +=7
					doc.setFontSize(22).setTextColor(0)
					if(car.dua_stock){
						doc.text(car.dua_stock, 8, mt)
					}else{
						doc.text("S/N", 8, mt)
					}
					// doc.setFontSize(8).setTextColor(0)
					// doc.text("MOTOR", 8, mt)
					// mt +=7
					// doc.setFontSize(22).setTextColor(0)
					// if(car.motor_number){
					// 	doc.text(car.motor_number, 8, mt)
					// }else{
					// 	doc.text("S/N", 8, mt)
					// }
					
					mt +=12
					doc.setFontSize(8).setTextColor(0)
					doc.text("MARCA", 8, mt)
					mt +=5
					doc.setFontSize(14).setTextColor(0)
					doc.text(car.brand.title, 8, mt)
					mt +=6
					doc.setFontSize(8).setTextColor(0)
					doc.text("MODELO", 8, mt)
					mt +=5
					
					// doc.text(car.model, 8, mt)
					doc.setFontSize(14).setTextColor(0)
					var splitModel = doc.splitTextToSize(car.model, 40);
					
					doc.text(splitModel, 8, mt);
					if(splitModel.length>1){
						mt = mt + (splitModel.length*6)
					}else{
						mt +=6
					}

					doc.setFontSize(8).setTextColor(0)
					doc.text("COLOR", 8, mt)
					mt +=5
					doc.setFontSize(14).setTextColor(0)
					doc.text(car.color.title, 8, mt)

					mt +=14
					doc.setFontSize(8)
					doc.text(now, 8, mt)

					// si hay otro agrego pagina
					if( this.form.cars.length > index+1){
						doc.addPage()
					}
				})
				doc.save('tags.pdf')

				// this.form.cars = []
			}
		},
		
	}
}


</script>


<style lang="scss">

</style>